<template>
    <section>
        <header>
            <nav>
                <ul>
                    <li><router-link v-show="$route.name!='Home'" to="/">&larr; Home</router-link></li>
                </ul>
                <ul>
                    <template v-if="$store.getters.isLoggedIn">
                        <li><router-link :to="{name: 'EditChecklist', params: {id:checklist.id, slug:checklist.slug}}"><i>Edit</i></router-link></li>
                    </template>
                    <li><print-button /></li>
                </ul>
            </nav>
        </header>
        <main>
            <section id="checklist">
                <header>
                    <p>
                        <sup v-for="tag in checklist.tags" :style="{backgroundColor: tag.color}">{{tag.name}}</sup>
                    </p>
                    <h1>{{checklist.title}}</h1>
                    <p>{{checklist.description}}</p>
                </header>
                <main>
                    <ul>
                        <li v-for="item_data in checklist.items">
                            {{item_data.item}}
                        </li>
                    </ul>
                </main>
            </section>
        </main>
    </section>
</template>

<script>
import PrintButton from '@/components/print-button.vue'

export default {
    name: 'ChecklistDetail',
    components: {
        PrintButton
    },
    props: [
        'id',
        'slug'
    ],
    data: function(){
        return {
            checklist: {}
        }
    },
    mounted() {
        fetch(`${process.env.VUE_APP_API_ROOT}/api/checklist/checklists/${this.id}/`, {
            method: "GET",
            headers: {
                Authorization: `token ${process.env.VUE_APP_API_TOKEN}`
            }
        })
            .then(response => response.json())
            .then(data => {
                this.checklist = data
            })
            .catch(error => console.log(error))
    }
}
</script>